import { memo } from "react";
import { useTypedSelector } from "hooks";
import useActions from "features/onboarding/useActions";
import { selectIsApplicationsLoading } from "features/onboarding/selectors";
import { ConfirmatableDialog } from "ui/molecules/Dialog";
import { Action, useApplicationTableResourceContext } from "../ApplicationTableResourceProvider";

const DeleteApplication = () => {
    const { context, onClose } = useApplicationTableResourceContext();
    const isApplicationsLoading = useTypedSelector(selectIsApplicationsLoading);
    const { deleteApplicaation } = useActions();

    const handleDeleteApplication = () => {
        const [request] = deleteApplicaation(context!.row);

        return request
            .then(onClose);
    };

    const content = {
        dialogContent: [
            `Are you sure you want to delete application ${context?.row.pki}?`
        ],
        actionContent: 'Yes'
    };

    return (
        <ConfirmatableDialog
            isProcessing={isApplicationsLoading}
            open={Object.is(context?.action, Action.DeleteApplication)}
            checkPredicate={() => false}
            content={[
                content,
                content
            ]}
            onConfirm={handleDeleteApplication}
            onCancel={onClose}
            slotProps={{
                confirmAction: {
                    color: 'error'
                }
            }}
        />
    );
};

export default memo(DeleteApplication);
